import { DynamicPictogram } from '@/components/pictograms/DynamicPictogram'
import { DynamicPictogramName } from '@/components/pictograms/types'

export function FormPictogramPreview({ pictogramName }: { pictogramName?: string | null }) {
  if (!pictogramName || pictogramName === '') return null
  return (
    <div className="flex flex-col gap-y-2">
      <div className="text-sm font-medium">Selected pictogram preview:</div>
      <div className="flex h-36 w-full items-center justify-center rounded-lg border bg-background p-5">
        <DynamicPictogram
          pictogramName={pictogramName as DynamicPictogramName}
          size={96}
          className="shrink-0"
          gradient
          lazyLoad={false}
          loadingFallback={<span className="size-24 shrink-0" />}
        />
      </div>
    </div>
  )
}
